import type { GrowthBook } from "@growthbook/growthbook";

import type { TestsNames } from "app/services/trackingServices/GrowthBookService";

export enum TestValues {
    CONTROL = "control",
    VARIATION = "variation",
    VARIATION_2 = "variation-2",
}

export type Tests = Record<keyof typeof TestsNames, TestValues>;

export interface IGrowthbookService {
    pageViewTracking(): { ab_test_name: string; ab_test_value: string } | null;
    growthbookInstance: GrowthBook;
}
